module.exports = __webpack_public_path__ + "static/media/hugodomingo.12076e7c.png";